import { Button, CardContent, CircularProgress, Divider, Grid, Typography } from "@mui/material";
import React, { useState } from "react";
import { useEffect } from "react";
import { Card } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Driverheader from "./Driverheader";
import { useDispatch, useSelector } from "react-redux";
import { Apiurl } from "../api_urls";
import { GToaster } from "../Components/g_toaster";
import axios from "axios";
import { editriderdata, riderlogin } from "../redux_store/RiderloginSlice";
import UploadImage from "../Components/UploadImage";
import ChangePasswordModal from "../Components/ChangePassword";

const toster = new GToaster()
function Driverprofile() {
    const navi = useNavigate();
    const driver = useSelector((state) => state?.data?.riderdata?.rider)
    const [userdata, setuserdata] = useState([driver])
    const [loading, setloading] = useState(false)
    const [modalOpen, setModalOpen] = useState(false);
    const dispatch = useDispatch()

    async function getuserdata() {
        const token = localStorage.getItem("access_token");
        const role = localStorage.getItem("role");
        await axios.get(`${Apiurl.GET_DRIVER_PROFILE_DETAILS_URL}${driver.id}`, {
            headers: {
                Authorization: `Bearer ${token}`,
                Role: role
            }
        }).then((res) => {
            if (res.data.status === 200) {
                dispatch(riderlogin(res.data.data))
                setuserdata([res.data.data])
            } else {
                setuserdata([])
            }
        }).catch((err) => {
            toster.error({ title: "Something went wrong Bookings data fetch" })
        })


    }

    function path(e) {
        dispatch(editriderdata(e))
        navi("/editriderdata")
        localStorage.removeItem("driver")
        localStorage.removeItem("drivername")
        window.location.reload()
    }

    const handleChange = (e) => {
        getuserdata()
    }


    const InactiverUser = async () => {
        setloading(true)
        const token = localStorage.getItem("access_token");
        const role = localStorage.getItem("role");
        let result = await axios.post(`${Apiurl.INACTIVE_RIDER_ACCOUNT}${driver.id}`, {}, {
            headers: {
                Authorization: `Bearer ${token}`,
                Role: role
            }
        });
        if (result?.data?.status === 200) {
            toster.success({ title: "Account Removed Successfully" })
            localStorage.removeItem("driver")
            localStorage.removeItem("drivername")
            localStorage.removeItem("persist:root")
            setloading(false)
            dispatch(riderlogin(null))
            navi("/rider")
        } else {
            setloading(false)
            toster.error({ title: "Server Error" })
        }
    }

    const onClose = () => {
        setModalOpen(false)
    }


    useEffect(() => {
        getuserdata()
    }, [])



    return (

        <>

            <Driverheader />
            <ChangePasswordModal open={modalOpen} onClose={onClose} usertype={"drivers"} uid={driver.id} />
            <Grid container spacing={4} padding={4}>
                <Grid item lg={4} xs={12}>
                    <UploadImage type={"driver"} id={driver?.id} handleChange={handleChange} photo={driver?.photo} />
                </Grid>

                <Grid item lg={6} md={12} sm={12} xs={12} >
                    <Card>
                        <CardContent>
                            {userdata.map((row) => (
                                <React.Fragment key={row?.id}>
                                    <div style={{ display: "flex", justifyContent: "space-between" }}>
                                        <Typography variant="h5" sx={{ py: 1, fontSize: { sm: "23px", xs: "12px" } }}> Your Profile Details</Typography>
                                    </div>
                                    <Divider sx={{mb:2,mt:1}}/>
                                    <div className="row">
                                        <div className="col-sm-3 col-xs-5 col-3">
                                            <p className="mb-0">Full Name</p>
                                        </div>
                                        <div className="col-sm-9 col-xs-8 col-9">
                                            <p className="text-muted mb-0">{row?.fullname}</p>
                                        </div>
                                    </div>
                                    <Divider sx={{mb:2,mt:1}}/>
                                    <div className="row">
                                        <div className="col-sm-3 col-xs-5 col-3">
                                            <p className="mb-0">Email</p>
                                        </div>
                                        <div className="col-sm-9 col-xs-8 col-9">
                                            <p className="text-muted mb-0">{row?.email}</p>
                                        </div>
                                    </div>
                                    <Divider sx={{mb:2,mt:1}}/>
                                    <div className="row">
                                        <div className="col-sm-3 col-xs-5 col-3">
                                            <p className="mb-0">Mobile Number</p>
                                        </div>
                                        <div className="col-sm-9 col-xs-8 col-9">
                                            <p className="text-muted mb-0">{row?.contact}</p>
                                        </div>
                                    </div>
                                    
                                 
                                    <Divider sx={{mb:2,mt:1}}/>
                                    <div className="row">
                                        <div className="col-sm-3 col-xs-5 col-3">
                                            <p className="mb-0">Address</p>
                                        </div>
                                        <div className="col-sm-9 col-xs-8 col-9">
                                            <p className="text-muted mb-0">{row?.address?.address}</p>
                                        </div>
                                    </div>
                                    <Divider sx={{mb:2,mt:1}}/>
                                    <div className="row">
                                        <div className="col-sm-3 col-xs-5 col-3">
                                            <p className="mb-0">City</p>
                                        </div>
                                        <div className="col-sm-9 col-xs-8 col-9">
                                            <p className="text-muted mb-0">{row?.address?.city}</p>
                                        </div>
                                    </div>
                                    <Divider sx={{mb:2,mt:1}}/>
                                    <div className="row">
                                        <div className="col-sm-3 col-xs-5 col-3">
                                            <p className="mb-0">Subpoint</p>
                                        </div>
                                        <div className="col-sm-9 col-xs-8 col-9">
                                            <p className="text-muted mb-0">{row?.address?.subpoint}</p>
                                        </div>
                                    </div>

                                    <Divider sx={{mb:2,mt:1}}/>
                                    <div className="row">
                                        <div className="col-sm-3 col-xs-5 col-3">
                                            <p className="mb-0">Vehicle Number</p>
                                        </div>
                                        <div className="col-sm-9 col-xs-8 col-9">
                                            <p className="text-muted mb-0">{row?.vehicle_number}</p>
                                        </div>
                                    </div>
                                    <Divider sx={{mb:2,mt:1}}/>
                                    <div className="row">
                                        <div className="col-sm-3 col-xs-5 col-3">
                                            <p className="mb-0">Vehicle Color</p>
                                        </div>
                                        <div className="col-sm-9 col-xs-8 col-9">
                                            <p className="text-muted mb-0">{row?.vehicle_color}</p>
                                        </div>
                                    </div>
                                    <Divider sx={{mb:2,mt:1}}/>
                                    <div className="row">
                                        <div className="col-sm-3 col-xs-5 col-3">
                                            <p className="mb-0">Vehicle Model</p>
                                        </div>
                                        <div className="col-sm-9 col-xs-8 col-9">
                                            <p className="text-muted mb-0">{row?.vehicle_model}</p>
                                        </div>
                                    </div>
                                    <Divider sx={{mb:2,mt:1}}/>
                                    <div style={{ display: "flex", justifyContent: "space-between" }}>
                                        <Button variant="contained" color="error" sx={{ mr: { sm: 4, xs: 1 }, fontSize: { sm: "12px", xs: "7px" } }} onClick={InactiverUser} disabled={loading}>{loading && <CircularProgress size={25} sx={{ color: "white" }} />} &nbsp;&nbsp;Delete Account</Button>
                                        <Button variant='contained' color='secondary' sx={{ fontSize: { sm: "13px", xs: "8px" } }} onClick={() => setModalOpen(true)} >
                                            Change Password
                                        </Button>
                                        <Button variant="contained" sx={{ fontSize: { sm: "12px", xs: "7px" } }} color="success" onClick={() => path(row)}>Update your Details</Button>
                                    </div>


                                </React.Fragment>
                            ))}


                        </CardContent>
                    </Card>
                </Grid>
            </Grid>




        </>

    )


}

export default Driverprofile;